import webCommonEN from "./en/web-common.json";
import webCommonES from "./es/web-common.json";
import onboardingDisabledEN from "./en/onboarding-disabled-message.json";
import onboardingDisabledES from "./es/onboarding-disabled-message.json";

const resources = {
  en: {
    "web-common": webCommonEN,
    "onboarding-disabled-message": onboardingDisabledEN,
  },
  es: {
    "web-common": webCommonES,
    "onboarding-disabled-message": onboardingDisabledES,
  },
};

export default resources;
